/**
 * Recursively processes a location and builds labels with parent paths
 * @param {Object} location - The location object with details
 * @param {string} prev_label - The previous label path
 * @param {Array} locationLabels - Array to collect location labels
 */
const recursiveLocations = (location, prev_label, locationLabels) => {
  let new_label = null;

  if (location.details && location.details.length > 0) {
    for (const detail of location.details) {
      if (location.id == detail.id) {
        new_label = prev_label;
      } else {
        new_label = prev_label + ' > ' + detail.name;
      }

      recursiveLocations(detail, new_label, locationLabels);
    }
  } else {
    locationLabels.push({ id: location.id, label: prev_label });
    return;
  }
};

/**
 * Processes an array of locations and returns location labels with parent paths
 * @param {Array} locations - Array of location objects
 * @returns {Array} Array of objects with { id, label } structure
 */
export const processLocations = (locations) => {
  const locationLabels = [];
  for (const location of locations) {
    recursiveLocations(location, location.name, locationLabels);
  }
  return locationLabels;
};

/**
 * Finds and returns the label for a given location ID
 * @param {number|string} id - The location ID to find
 * @param {Array} locationLabels - Array of location label objects
 * @returns {string|null} The label if found, null otherwise
 */
export const getLocationLabel = (id, locationLabels) => {
  const found = locationLabels.find((e) => e.id == id);
  return found ? found.label : null;
};

export default {
  processLocations,
  getLocationLabel,
};
